import { Image } from './Image';

export const Home: Image[] = [
  { src: '/assets/home/home-1.jpg'},
  { src: '/assets/home/home-2.jpg'},
  { src: '/assets/home/home-3.jpg'}
];
